import { render } from "./StaffAttendance.vue?vue&type=template&id=b7e36934&scoped=true"
import script from "./StaffAttendance.vue?vue&type=script&lang=js"
export * from "./StaffAttendance.vue?vue&type=script&lang=js"

import "./StaffAttendance.vue?vue&type=style&index=0&id=b7e36934&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e36934"]])

export default __exports__